import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  addedActors: {
    id: 'addedActors',
    defaultMessage: 'Added actors',
  },
  searchResults: {
    id: 'searchResults',
    defaultMessage: 'Search results',
  },
  notFoundActor: {
    id: 'notFoundActor',
    defaultMessage: "We can't find actor with this name",
  },
  notFoundActorDescr: {
    id: 'notFoundActorDescr',
    defaultMessage:
      "Maybe, you don't have access to this actor, or it did not exist yet.",
  },
  searchActors: {
    id: 'searchActors',
    defaultMessage: 'Search actors',
  },
});

export default { ...globalIntl, ...m };
